import { render, staticRenderFns } from "./hojas-seguridad-editar.vue?vue&type=template&id=5bd04308&scoped=true&"
import script from "./hojas-seguridad-editar.vue?vue&type=script&lang=js&"
export * from "./hojas-seguridad-editar.vue?vue&type=script&lang=js&"
import style0 from "./hojas-seguridad-editar.vue?vue&type=style&index=0&id=5bd04308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd04308",
  null
  
)

export default component.exports